import React from 'react'
import styled from 'styled-components'
import { NavBar } from '../../components/navbar'
import { featured_icon } from '../../assets'
import { colors } from '../../colors'
import { Button } from '../../components/button'
import { Link } from 'react-router-dom'
import { IoMdArrowBack } from 'react-icons/io'

import { 
    Container,
    InputContainer
 } from '../signup'


const ForgotPassword = () => {
  return (
    <Container>
        <NavBar/>

        <form >
            <img src={featured_icon} alt="" />
            <h1>Forgot password?</h1>
            <p>No worries, we’ll send you reset instructions.</p>
            
            <InputContainer>
                <label htmlFor="name">Email</label>
                <input name='email' type="email" placeholder='Enter your email' required />
            </InputContainer>

            <Button filled bgColor={'#2A870E'} noIcon text={'Forgot password'} />

        </form>
        <small>  <Link to='/login'> <IoMdArrowBack/> Back to log in</Link> </small>
    </Container>
  )
}



export {ForgotPassword}